import type { PatientDto } from "@repo/data-store";
import { CommandEmpty, CommandGroup, CommandItem } from "@repo/ui/components/ui/command";
import { getPatientName } from "@/shared/lib/patient-utils";

export interface PatientSearchListProps {
  patients: PatientDto[];
  onSelect: (patientId: string) => void;
  /** Optional render to prepend inside each item (e.g. check icon) */
  renderPrefix?: (patient: PatientDto) => React.ReactNode;
}

export function PatientSearchList({ patients, onSelect, renderPrefix }: PatientSearchListProps) {
  return (
    <>
      <CommandEmpty>No patients found.</CommandEmpty>
      <CommandGroup>
        {patients
          .filter((patient) => patient.patientId)
          .map((patient) => {
            const name = getPatientName(patient);
            const email = patient.telecom?.find((t) => t.system === "email")?.value;
            const dob = patient.birthDate
              ? new Date(patient.birthDate).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })
              : null;
            const details = [dob, email].filter(Boolean).join(" · ");

            return (
              <CommandItem key={patient.patientId} value={name} onSelect={() => onSelect(patient.patientId)}>
                {renderPrefix?.(patient)}
                <div className="flex flex-col">
                  <span>{name}</span>
                  {details && <span className="text-xs text-muted-foreground">{details}</span>}
                </div>
              </CommandItem>
            );
          })}
      </CommandGroup>
    </>
  );
}
